export const XRAY_2D_3D_VIEW_IDS = ['ap', 'left-oblique', 'right-oblique'] as const;

export const XRAY_HIP_SPINE_VIEW_IDS = ['standing-sagittal', 'flexed-seated-sagittal', 'lumbar-sagittal'] as const;

export type XRay2D3DViewId = typeof XRAY_2D_3D_VIEW_IDS[number];

export type XRayViewId = typeof XRAY_2D_3D_VIEW_IDS[number] | typeof XRAY_HIP_SPINE_VIEW_IDS[number];